<template>
  <div>
      <div class="form-group" v-for="group in state.productsView.AllFilterGroups" :key="group.Id">
          <ul id="tags-list" class="filter" data-type="tags">
              <li class="group-title">
                  {{ group.Name }}
              </li>
              <app-filter v-for="filter in getFiltersByGroup(group.Id)" 
                          :key="filter.Id" 
                          :filter="filter">
              </app-filter>
              
          </ul>
      </div>
  </div>
</template>
<script>
  
  import filter from './filter.vue';
  import { store } from './../store.js';

  export default {
      components: {
          'appFilter': filter
      },
      data: function () {
          return {
              state: store.state
          }
      },
      methods: {
          getFiltersByGroup: function (groupId) {
              var tags = store.getFiltersByGroup(groupId);
              return tags;
          }
      }
  }
</script>